import { _Activity } from "./Activities";

const ACTIVITES: Array<_Activity> = [
  {
    label: "Sport",
    name: "sports",
    cover: "/activities/sports.png",
    modal: {
      accident: (
        <p>
          Jonathan glisse sur le sol humide de la piscine en voulant éviter un
          enfant. Il tombe sur la nuque et se blesse la colonne cervicale ...
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : Les dommages causés par la chute sont multiples :
          traumatisme crânien avec fracture déplacée C1-C2 et atteinte de la
          moelle épinière cervicale provoquant une tétraplégie haute complète
          avec troubles cognitifs résiduels. L&apos;expertise médicale évalue
          les séquelles de l&apos;accident à <b>95% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Jonathan aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier
          d&apos;un service de soutien psychologique au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>47 500 € s&apos;il avait souscrit au niveau 1</li>
            <li>95 500 € s&apos;il avait souscrit au niveau 2</li>
            <li>142 500 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Vélo",
    name: "cycling",
    cover: "/activities/bike.png",
    modal: {
      accident: (
        <p>
          Pierre va faire ses courses en vélo, il roule sur une zone en travaux
          et chute violemment de son vélo contre le trottoir coté droit...
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : En tombant de son vélo, Pierre s&apos;est violemment
          cogné la tête, l&apos;épaule droite, le coude droit, la hanche droite
          . Le casque n&apos;a pas suffi à éviter son traumatisme crânien, le
          coude est cassé. Il vit désormais avec une altération légère de la
          mémoire entraînant des oublis dans sa vie quotidienne, une limitation
          d&apos;extension du coude droit chez un droitier. La hanche est
          indemne de séquelle. Il persiste un stress post traumatique avec
          conduite d&apos;évitement. L&apos;expertise médicale évalue les
          séquelles de l&apos;accident à <b>18% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Pierre aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier
          d&apos;un service d&apos;appels de convivialité afin de lui apporter
          du réconfort et/ou l&apos;aider à restaurer le lien social au titre
          des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>9 000 € s&apos;il avait souscrit au niveau 1</li>
            <li>18 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>27 000 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Randonnée",
    name: "hiking",
    cover: "/activities/hiking.png",
    modal: {
      accident: (
        <p>
          Jacqueline part à la montagne randonner et glisse sur un rocher suite
          à un orage imprévu…
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : Entorse grave du ligament croisé antérieur avec
          instabilité de son genou gauche. L&apos;expertise médicale évalue les
          séquelles de l&apos;accident à <b>8% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Jacqueline aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier de la
          livraison de ses courses au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>4 000 € s&apos;il avait souscrit au niveau 1</li>
            <li>8 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>12 000 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Cuisine",
    name: "cooking",
    cover: "/activities/cooking.png",
    modal: {
      accident: (
        <p>
          Emilie est en train de cuisiner. La casserole d&apos;eau bouillante
          lui échappe des mains lorsque son chat passe derrière elle…
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : Brûlure de 7% du bras gauche au 2ème degré, perte de
          la mobilité au niveau du pouce de la main gauche. L&apos;expertise
          médicale évalue les séquelles de l&apos;accident à{" "}
          <b>5% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Emilie aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier du
          portage de ses repas au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>2 500 € s&apos;il avait souscrit au niveau 1</li>
            <li>5 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>7 500 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Jardinage",
    name: "gardening",
    cover: "/activities/gardening.png",
    modal: {
      accident: (
        <p>
          Patrick taille la haie de son jardin. L&apos;outil s&apos;avère lourd
          à bout de bras, se bloque sur une branche et lui échappe des mains…
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat :</b> la perte des cinq orteils de son pied gauche.
          L&apos;expertise médicale évalue les séquelles de l&apos;accident à{" "}
          <b>15% d&apos;AIPP*</b> et Patrick est immobilisé pendant 20 jours.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Patrick aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier de la
          garde de ses enfants pendant son immobilisation au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>7 500 € s&apos;il avait souscrit au niveau 1</li>
            <li>15 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>22 500 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Bricolage",
    name: "handiwork",
    cover: "/activities/handiwork.png",
    modal: {
      accident: (
        <p>
          Estelle monte plusieurs meubles qu&apos;elle a acheté pour son nouveau
          logement lorsqu&apos;une chute de planche écrase ses trois derniers
          doigts de la main droite (elle est gauchère)… Elle fait des
          complications suite à de nombreuses opérations réparatrices.
        </p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : Impossibilité partielle de bouger les 3 derniers
          doigts de la main droite. L&apos;expertise médicale évalue les
          séquelles de l&apos;accident à <b>12% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Estelle aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier
          d&apos; aide-ménagère au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>6 000 € s&apos;il avait souscrit au niveau 1</li>
            <li>12 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>18 500 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
  {
    label: "Sortie en famille ou entre amis",
    name: "outings",
    cover: "/activities/outing.png",
    modal: {
      accident: (
        <p>Morgane se rend à la piscine et rate son plongeon de la falaise…</p>
      ),
      blessure: (
        <p>
          <b>Résultat</b> : Elle se cogne la tête et s&apos;évanouit dans
          l&apos;eau. Léon saute dans l&apos;eau et la sauve in extremis. A la
          suite de cet accident, elle développe une névrose traumatique.
          L&apos;expertise médicale évalue les séquelles de l&apos;accident à{" "}
          <b>12% d&apos;AIPP*</b>.
        </p>
      ),
      indemnisation: (
        <span>
          Avec le contrat Paxivie, Morgane aurait perçu une{" "}
          <b>indemnité forfaitaire par % d&apos;AIPP</b> au titre de la garantie
          accidents de la vie courante, et aurait également pu bénéficier
          d&apos;un accompagnement par un psychologue au titre des garanties{" "}
          <b>
            d&apos;assistance disponibles 7j/7 et 24h/24 (sous réserve des
            limites, exclusions et risques non couverts)
          </b>{" "}
          :
          <ul>
            <li>6 000 € s&apos;il avait souscrit au niveau 1</li>
            <li>12 000 € s&apos;il avait souscrit au niveau 2</li>
            <li>18 000 € s&apos;il avait souscrit au niveau 3</li>
          </ul>
        </span>
      ),
    },
  },
];

export default ACTIVITES;
